import React from 'react'
import { Dropdown } from 'primereact/dropdown'
import './../form.scss'
import { PropsType } from '../../../models/util'

interface SelectProps extends PropsType {
    onChangeCallback: (e: any) => void // on change callback
    value: string | number // input value

    // to override primereact and/or wardrobe styles, use custom classes
    classes?: string // css classes for the element
    containerClasses?: string // css classes for the <div> container
    style?: any

    optionsList?: any[] // options list for select and multiselect
    filterable?: boolean // adds searchbar for select and multiselect dropdowns

    mandatory?: boolean // adds * in labels (TODO validation message)
    disabled?: boolean // if true the element is disabled
    colWidth?: number | string // set element width from 1 to 12 columns (default: 12)

    label?: string // label
    floatingLabel?: boolean // floating labels appear only when the field is filled in
    placeholder?: string // placeholder

    additionalProps?: any // pass props for the Prime React original component
    itemTemplate?: any // dropdown options items template
    panelClassName?: string // panel className
    clearable?: boolean // add 'x' icon to clear the field

    // the dropdown icon is not customizable
}

const Select = (props: SelectProps) => {
    const {
        onChangeCallback,
        optionsList,
        value,
        placeholder,
        disabled,
        additionalProps,
        containerClasses,
        classes,
        style,
        floatingLabel,
        label,
        filterable,
        colWidth,
        mandatory,
        itemTemplate,
        panelClassName,
        clearable,
    } = props

    return (
        <div
            className={`wardrobe-form-input p-col-${
                colWidth ? colWidth : '12'
            } ${containerClasses ? containerClasses : ''} ${
                label ? 'labeled-input' : ''
            }`}>
            <Dropdown
                style={style}
                dropdownIcon="cu cu-caret-down"
                value={value}
                options={optionsList}
                placeholder={placeholder}
                disabled={disabled}
                onChange={(e: any) => {
                    // prevent keyboard selection
                    if (e.originalEvent.type === 'keydown') return
                    onChangeCallback(e.target.value)
                }}
                filter={filterable}
                className={`w-100 ${classes}`}
                panelClassName={`wardrobe-form-panel ${panelClassName}`}
                itemTemplate={itemTemplate}
                showClear={clearable}
                {...additionalProps}
            />
            {label && (
                <label className={`${floatingLabel && !value ? 'empty' : ''}`}>
                    {`${label}${mandatory ? ' *' : ''}`}
                </label>
            )}
        </div>
    )
}

export default Select
